import { AppContextInterface, useAppContext } from '../contexts/auth';

interface GeneralAppData extends AppContextInterface {
  isCustoemer: boolean;
}

export default function useGetGeneralAppData() {
  const {
    userData,
    selectedCompany,
    handleSelectedCompanyChange,
    companiesList,
    setCompaniesList,
    isDifferentSubdomain,
  }: GeneralAppData = useAppContext();
  const { userName, userProfile, userCode, page, companyCode: usersCompanyCode, companyLabel: usersCompanyLabel, permissions, services } = userData;
  const { value, label } = selectedCompany;
  const companyCode = value;
  const companyName = label;
  const isCustomer = userProfile >= 10;
  const usersAllowedToAccessFinancial = (
    process.env.REACT_APP_USERS_ALLOWED_TO_ACCESS_FINANCIAL
    || process.env.REACT_APP_USERS_CAN_ACCESS_FINANCIAL
  )?.split(',').map((id) => id.trim()).filter(Boolean) || ['194', '2', '13'];

  const usersAllowedToAccessIago = (
    process.env.REACT_APP_USERS_ALLOWED_TO_ACCESS_IAGO
    || process.env.REACT_APP_USERS_CAN_ACCESS_IAGO
  )?.split(',').map((id) => id.trim()).filter(Boolean) || ['194', '2', '13', '197', '210'];

  const canAccessFinancial = usersAllowedToAccessFinancial.includes(String(userCode).trim());
  const canAccessIago = canAccessFinancial || usersAllowedToAccessIago.includes(String(userCode).trim());

  return {
    userName,
    userProfile,
    userCode,
    permissions,
    services,
    companyCode,
    companyName,
    page,
    usersCompanyCode,
    usersCompanyLabel,
    handleSelectedCompanyChange,
    companiesList,
    setCompaniesList,
    isCustomer,
    isDifferentSubdomain,
    canAccessFinancial,
    canAccessIago,
  };
}
